// extracted by mini-css-extract-plugin
module.exports = {"media":"mediaDestacat_media__Q_0o0","imatge":"mediaDestacat_imatge__6c_Gp","peuFoto":"mediaDestacat_peuFoto__lngU0","audio":"mediaDestacat_audio__JYeVb"};